<app-dialog-base [titleTranslationKey]="data.titleTranslationKey" [titleInterpolateParams]="data.titleInterpolateParams"
  [resultOnClose]="resultOnClose">
  <ng-container content>
    <p class="confirm-text">{{ data.textTranslationKey | translate: data.textInterpolateParams }}</p>
  </ng-container>

  <ng-container actions>
    <button mat-stroked-button color="primary" (click)="cancel()">{{ cancelKey | translate }}</button>
    <!--suppress HtmlUnknownAttribute -->
    <button mat-flat-button color="primary" (click)="confirm()" cdkFocusInitial>{{ okKey | translate }}</button>
  </ng-container>
</app-dialog-base>
